import {Navigable} from '@synako/halitrek';
import {useHalState} from '@synako/haligator';
import {ClientDesc} from 'api-types/ffconnect-hal';

/**
 * Indique si les prix doivent s'afficher en TTC : l'affichage en TTC a été activé pour le client.
 * Un métier qui impose le TTC (Filiales / Personnel) arrive déjà à `active` depuis le serveur.
 * Le client est passé en paramètre : chaque application fournit le sien via son propre `useClient`.
 */
export const useAffichagePrixTtc = (client: Navigable<ClientDesc>): boolean => {
  const {data, state} = useHalState(client);
  // Les marges (VM/TM/MK) sont calculées sur le HT : qui les voit reste en HT sur tous les écrans
  const voitLesMarges = state?.hasOneLink('peut-voir-marges') ?? false;
  return data?.affichage_prix_ttc === 'active' && !voitLesMarges;
};
